import { runtimeConfig } from "../../config/runtimeConfig";

const DEVICE_TOKEN_STORAGE_KEY = "web_device_token";

/**
 * Per-browser device token (persisted). Replaces the shared "123456" constant
 * that caused cross-user device_token collisions on register/login.
 */
function resolveDeviceToken() {
    try {
        let token = localStorage.getItem(DEVICE_TOKEN_STORAGE_KEY);
        if (!token) {
            if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
                token = crypto.randomUUID();
            } else {
                token =
                    "web-" +
                    Date.now().toString(36) +
                    "-" +
                    Math.random()
                        .toString(36)
                        .slice(2, 12);
            }
            localStorage.setItem(DEVICE_TOKEN_STORAGE_KEY, token);
        }
        return token;
    } catch (e) {
        return "web-fallback-" + Date.now().toString(36);
    }
}

export const apiConstants = {
    // Common variables

    LOGIN_BY: "manual",

    DEVICE_TYPE: "web",

    DEVICE_TOKEN: resolveDeviceToken(),

    // Song download status

    DOWNLOAD_INITIATE_STAUTS: 1,

    DOWNLOAD_PROGRESSING_STAUTS: 2,

    DOWNLOAD_PAUSE_STAUTS: 3,

    DOWNLOAD_COMPLETE_STAUTS: 4,

    DOWNLOAD_CANCEL_STAUTS: 5,

    // Wishlist status

    WISHLIST_CLEAR_ALL: 1,

    WISHLIST_CLEAR_SINGLE_AUDIO: 0,

    // History status

    HISTORY_CLEAR_ALL: 1,

    HISTORY_CLEAR_SINGLE_AUDIO: 0,

    // PAGE TYPES

    PRIVACY_PAGE_TYPE: "privacy",

    TERMS_PAGE_TYPE: "terms",

    // Hisotry status

    HISTORY_INITIATE_STATUS: 1,

    HISTORY_COMPLETE_STATUS: 2,

    HISTORY_DELETE_STATUS: 3,

    USER_API_CALL: "/user",

    HOST_API_CALL: "/provider",

    SERIES: 21,

    MOVIES: 25,

    RECENTLY_ADDED: 33,

    CATEGORY: 54,

    KIDS: 12,

    // Social Login Credentials — runtime values come from settings API client IDs

    GOOGLE_CLIENT_ID: "",

    FACEBOOK_APP_ID: "",

    // Prefer configData JW key from settings when available; fallback for legacy embeds
    JWPLAYER_KEY: "M2NCefPoiiKsaVB8nTttvMBxfb1J3Xl7PDXSaw==",

    // Hosted endpoints — from runtimeConfig (REACT_APP_*; production defaults if unset)
    settingsUrl: runtimeConfig.settingsUrl,

    homeSettingsUrl: runtimeConfig.homeSettingsUrl,

    socketUrl: runtimeConfig.socketUrl
};
